import { useEffect, useRef } from 'react';

const VideoSection = () => {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.video-reveal').forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = '1';
                (el as HTMLElement).style.transform = 'translateY(0)';
              }, i * 200);
            });
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="video" className="relative bg-[#0a0a0a] py-24 md:py-32 overflow-hidden">
      {/* Cyan glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-cyan-500/5 blur-3xl pointer-events-none" />

      <div ref={sectionRef} className="relative z-10 max-w-5xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-12">
          <div
            className="video-reveal inline-flex items-center gap-2 border border-cyan-500/40 bg-cyan-500/10 text-cyan-400 text-xs font-semibold uppercase tracking-widest px-4 py-2 rounded-full mb-5"
            style={{ opacity: 0, transform: 'translateY(30px)', transition: 'opacity 0.7s ease, transform 0.7s ease' }}
          >
            <i className="ri-film-line text-cyan-400" />
            Nuestro Equipo en Acción
          </div>
          <h2
            className="video-reveal text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4"
            style={{ opacity: 0, transform: 'translateY(30px)', transition: 'opacity 0.7s ease, transform 0.7s ease' }}
          >
            Tecnología LED{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-sky-500">
              de verdad
            </span>
          </h2>
          <p
            className="video-reveal text-gray-400 text-base md:text-lg max-w-2xl mx-auto"
            style={{ opacity: 0, transform: 'translateY(30px)', transition: 'opacity 0.7s ease, transform 0.7s ease' }}
          >
            Así es como trabajamos. Nuestros paneles LED P5 HD Outdoor, con mecanismo de curvatura ajustable y construcción profesional para cualquier tipo de evento.
          </p>
        </div>

        {/* Video Container */}
        <div
          className="video-reveal relative rounded-2xl overflow-hidden border border-cyan-500/20 group"
          style={{ opacity: 0, transform: 'translateY(30px)', transition: 'opacity 0.7s ease, transform 0.7s ease' }}
        >
          {/* Glow border */}
          <div className="absolute -inset-px rounded-2xl bg-gradient-to-r from-cyan-500/20 to-sky-500/20 blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />

          <div className="relative aspect-video bg-black">
            <video
              src="https://storage.readdy-site.link/project_files/06aadc1d-6920-43e8-b307-dffb1d65b532/0d4de9fe-412e-4484-8d77-4bc81080d363_WhatsApp-Video-2026-06-09-at-12.52.31.mp4?v=68567fcd1358710783dd5359be372054"
              controls
              poster="https://storage.readdy-site.link/project_files/06aadc1d-6920-43e8-b307-dffb1d65b532/03705b76-babe-4524-8d81-3e47574029e5_WhatsApp-Image-2026-06-09-at-12.52.32-1.jpeg?v=1a806b64fdcdf46cd0b7323f55b51df0"
              className="w-full h-full object-cover"
              aria-label="Video de Astro Screen mostrando paneles LED en acción"
            >
              Tu navegador no soporta video HTML5.
            </video>
          </div>
        </div>

        {/* Specs below */}
        <div
          className="video-reveal mt-10 grid grid-cols-2 md:grid-cols-4 gap-4"
          style={{ opacity: 0, transform: 'translateY(30px)', transition: 'opacity 0.7s ease, transform 0.7s ease' }}
        >
          {[
            { label: 'Modelo', value: 'P5 HD Outdoor' },
            { label: 'Curvatura', value: '-15° a +15°' },
            { label: 'Protección', value: 'Waterproof IP65' },
            { label: 'Tamaño', value: '3 x 2 metros' },
          ].map((spec) => (
            <div
              key={spec.label}
              className="flex flex-col items-center text-center bg-[#1a1a1a] border border-cyan-500/10 rounded-xl px-4 py-5 hover:border-cyan-500/30 transition-colors duration-300"
            >
              <span className="text-cyan-400 text-xs font-semibold uppercase tracking-wider mb-1">{spec.label}</span>
              <span className="text-white font-bold text-sm md:text-base">{spec.value}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoSection;